import React, {useEffect, useState} from 'react';
import s from './NavBar.module.css'
import './NavBar.css'
import {Link, NavLink, useLocation, useNavigate} from "react-router-dom";
import classnames from "classnames";
import closePopup from "../../../assets/images/mobile/close_popup.svg"
import logo from "../../../assets/images/logo_black.svg"
import arrow_dropdown from "../../../assets/images/publicPages/arrow_dropdown.svg";
import {
    SERVICES, 
    COMPANY,
    CONTACT_US,
    ABOUT_US,
    PERSONAL
} from "../../../constants/RoutesConstants";
import Icon from "@ant-design/icons";
import {ReactComponent as CardCoin} from '../../../assets/images/publicPages/card-coin.svg'
import {ReactComponent as WalletMoney} from '../../../assets/images/publicPages/wallet-money.svg'
import {ReactComponent as Transfer} from '../../../assets/images/publicPages/transfer.svg'
import {ReactComponent as Medal} from '../../../assets/images/publicPages/medal-star.svg'
// import {ReactComponent as WhiteLabel} from '../../../assets/images/publicPages/whitelabel.svg'
// import {ReactComponent as Iban} from '../../../assets/images/publicPages/iban.svg'
import TransparentButton from "../../ui/TransparentButton/TransparentButton";
import SideMenu from "../../SideMenu/SideMenu";
import {useAppSelector} from "../../../hooks/redux";
import MyBtn from '../../ui/MyBtn/MyBtn';
import { DropDown } from '../../ui/DropDown/DropDown';

type propsType = {
    isActive: boolean
    setIsActive: (boolean: boolean) => void
}

const NavBar = ({isActive, setIsActive}: propsType) => {
    const [IsPersonalSideMenu, setIsPersonalSideMenu] = useState(false)
    const [isOpen, setIsOpen] = useState(false) // Состояние для дропдауна
    const location = useLocation()
    const navigate = useNavigate()
    const isLogin = useAppSelector(state => state.userReducer.user.userToken)

    useEffect(() => {
        if (
            location.pathname.includes("login") ||
            location.pathname.includes("sign-up") ||
            location.pathname.includes("personal_account")
        ) {
            setIsPersonalSideMenu(true)
        } else {
            setIsPersonalSideMenu(false)
        }
    }, [location.pathname])

    const handleNavigate = (path: any) => {
        setIsActive(false)
        navigate(path)
    }

    const closeBurgerMenu = () => {
        setIsActive(false);
    };

    // Функция для закрытия меню при клике на ссылку
    const closeMenu = () => {
        setIsActive(false);
        setIsOpen(false); // Закрываем дропдаун
    };

    // Функция для обработки клика по ссылке в дропдауне
    const handleLinkClick = (url: string) => {
        closeMenu();
        navigate(url);
    };

    return (
        <>
            {
                IsPersonalSideMenu
                    ? <div className={classnames(s.myPopup, isActive ? s.active : s.inactive)}>
                        <SideMenu isSide setIsActive={setIsActive}/>
                    </div>
                    : <div className={classnames(s.myPopup, isActive ? s.active : s.inactive)}>
                        
                        <div className={s.close_img_block}>
                            <Link to="/" onClick={closeBurgerMenu}>
                                <img src={logo} alt="" className={s.mobile_logo}/>
                            </Link>
                            <img src={closePopup} className={s.closeImg} alt="" onClick={() => setIsActive(false)}/>
                        </div>
                        <div className={s.links_block}>
                            <Link className={s.link} to={ABOUT_US} onClick={closeBurgerMenu}>About</Link>
                            <DropDown 
                                closeMenu={closeMenu}
                                buttonLabel='Services'
                                handleLinkClick={handleLinkClick}
                                isOpen={isOpen}
                                setIsOpen={setIsOpen}
                                items={[
                                    { title: 'Our Services', url: "/services"},
                                    { title: 'Cards', url: "/services-cards"},
                                    { title: 'Commercial Banking', url: "/commercial-banking"},
                                    { title: 'Private Banking', url: "/private-banking"},
                                    { title: 'Saving Account', url: "/saving-accounts"},
                                    { title: 'Digital Assets Banking', url: "/digital-assets-banking"},
                                ]}
                            />        
                            <Link className={s.link} to={COMPANY} onClick={closeBurgerMenu}>Company</Link>
                            <Link className={s.link} to={CONTACT_US} onClick={closeBurgerMenu}>Contact Us</Link>
                            <Link className={s.link} to={PERSONAL} onClick={closeBurgerMenu}>Personal</Link>
                        </div>
                        <div className={s.buttons_block}>
                            <Link to={"/login"}>
                                <TransparentButton title={"Sign In"}/>
                            </Link>

                            <Link to={"/sign-up"}>
                                <MyBtn title={"Open account"} style={{width: "180px"}}/>
                            </Link>
                        </div>
                    </div>
            }
        </>
    );
};

export default NavBar;